
import {
  Vue, Component, Prop,
} from 'vue-property-decorator';
import {
  Lead, PermissionCode, ProjectsPool, Task, BoxStatusType,
} from '@/types';
import {
  currentUserHasPermission, getLeadCustomValueText,
} from '@/helpers';

@Component
export default class CheckAccountGSE extends Vue {
  @Prop({ type: Boolean, default: false }) readonly readonly!: boolean;

  get pool(): ProjectsPool {
    return this.$store.getters.currentPool;
  }

  get currentLead() {
    return this.$store.getters.currentLead;
  }

  get lead() {
    return this.isFather
      ? this.currentLead
      : this.father;
  }

  get father(): Lead | null {
    const firstTask: Task = this.currentLead.Tasks[0];
    const { fatherLeadId } = firstTask;

    return fatherLeadId && fatherLeadId in this.pool
      ? this.pool[fatherLeadId]
      : null;
  }

  get isChild(): boolean {
    return ['installatore-figlia', 'elettrica-figlia', 'termica-figlia'].includes(this.currentLead?.type);
  }

  get isFather(): boolean {
    return !this.isChild;
  }

  hasPermission(codename: PermissionCode): boolean { return currentUserHasPermission(codename); }

  boxText(boxStatus: BoxStatusType): string {
    switch (boxStatus) {
      case 'todo':
        return 'Da fare';

      case 'done':
        return 'Fatto';

      case 'waiting':
        return 'In attesa';

      case 'na':
        return 'Non applicabile';

      default:
        break;
    }

    return 'Non disponibile';
  }

  boxColor(boxStatus: BoxStatusType): string {
    switch (boxStatus) {
      case 'na':
      case 'todo':
        return 'grey';

      case 'done':
        return 'success';

      case 'waiting':
        return 'orange';

      default:
        break;
    }

    return '';
  }

  boxDark(boxStatus: BoxStatusType): boolean {
    switch (boxStatus) {
      case 'todo':
      case 'done':
      case 'waiting':
        return true;

      case 'na':
        return false;

      default:
        break;
    }

    return true;
  }

  boxOutlined(boxStatus: BoxStatusType): boolean {
    switch (boxStatus) {
      case 'todo':
      case 'done':
      case 'waiting':
        return false;

      case 'na':
        return true;

      default:
        break;
    }

    return false;
  }

  checkAccountGSEStatus() {
    return (getLeadCustomValueText(this.lead, 'checkAccountGSE') ?? 'todo') as BoxStatusType;
  }

  get checkAccountGSEBoxDark() {
    return this.boxDark(this.checkAccountGSEStatus());
  }

  get checkAccountGSEBoxOutlined() {
    return this.boxOutlined(this.checkAccountGSEStatus());
  }

  get checkAccountGSEBoxColor() {
    return this.boxColor(this.checkAccountGSEStatus());
  }

  get checkAccountGSELabel() {
    return this.boxText(this.checkAccountGSEStatus());
  }

  get isEditable() {
    if (!this.lead || this.readonly) return false;

    return (this.lead?.status === 'open' || this.lead?.status === 'new')
      && this.hasPermission('taskcm.checkAccountGSE.edit');
  }

  onEdit() {
    console.log(`${this.constructor.name}: onEdit()`); // eslint-disable-line no-console

    this.$emit('edit');
  }
}
